var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0876 7.97474C5.68827 10.9923 9.24891 12.8268 13.0405 12.072C13.4805 11.9845 13.9042 11.8659 14.3087 11.7199C15.9734 11.1192 16.0811 13.9012 16.5879 14.2061C17.4479 14.7235 16.6557 10.5409 17.4626 9.63645C18.5856 8.3776 19.1293 6.80417 18.8182 5.2416C18.2176 2.22399 14.6569 0.389563 10.8653 1.1443C7.0737 1.89903 4.48694 4.95712 5.0876 7.97474Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90873 8C1.22123 9.43883 0.505484 11.6429 1.29172 13.5592C1.81707 14.8397 2.91003 15.7407 4.23736 16.1496C5.19104 16.4433 4.17568 19.7672 4.5 19C4.69111 18.5479 5.91029 16.5557 7.28669 16.2391C7.62108 16.1621 7.9554 16.0565 8.2859 15.9209C9.16475 15.5603 9.91395 15.03 10.5 14.3963",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.ac63e3d61cf0153ea46494e5ae717740.svg";
export { ForwardRef as ReactComponent };